import * as constants from '../constants';
import converter from '../converter';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getHarmfulObject.success: {
            return action.payload;
        }

        case constants.getHarmfulObject.error: {
            return { error: 'backend error' };
        }

        default:
            return state;
    }
}
